import { v4 as randomId } from "uuid";
import { DraftImage, MaterialBlock, MedicineMaterial } from "./types";

export const createDraftImage = (): DraftImage => ({
  key: randomId(),
});

export const createNewBlock = (): MaterialBlock => ({
  key: randomId(),
  caption: "",
  materials: [],
  drafts: [createDraftImage()],
  isNew: true,
});

export const isS3Image = (imageUrl?: string) => {
  return !!imageUrl && !/^https?:\/\//i.test(imageUrl);
};

export const groupMaterials = (
  materials: MedicineMaterial[]
): MaterialBlock[] => {
  const groups = materials.reduce<Record<string, MedicineMaterial[]>>(
    (acc, material) => {
      const caption = material.caption || "Без названия";
      acc[caption] = acc[caption] || [];
      acc[caption].push(material);
      return acc;
    },
    {}
  );

  return Object.entries(groups).map(([caption, items]) => ({
    key: caption,
    caption,
    materials: [...items].sort((a, b) => (a.ord ?? 0) - (b.ord ?? 0)),
    drafts: [],
  }));
};

export const getFilledDrafts = (drafts: DraftImage[]) => {
  return drafts.filter((draft) => draft.imageUrl || draft.detailImage);
};
